import HistoricalArbitrageTransactionDetails from './historical-arbitrage-transaction-details.vue'
export default HistoricalArbitrageTransactionDetails
